var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVolumeMute = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293 586 l-72 -64 92 -88 92 -89 3 139 c4 193 -4 200 -115 102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 621 c-4 -5 69 -83 161 -173 293 -286 312 -303 326 -289 9 9 -38 61 -223 241 -129 126 -240 229 -247 229 -6 1 -14 -3 -17 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 493 c-4 -3 -7 -41 -7 -83 0 -92 6 -99 87 -107 53 -5 64 -11 124 -64 62 -55 115 -78 107 -46 -5 19 -304 308 -311 300z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVolumeMute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-volume-mute.61092583bb52e96ef1b806c7079b722a.svg";